(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/fill.js', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/fill.js'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.fill, global.convert);
    global.fill = mod.exports;
  }
})(this, function (exports, _fill2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.fill = undefined;

  var _fill3 = _interopRequireDefault(_fill2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array filled with value from start up to, but not including, end.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {*} value The value to fill array with.
   * @param {number} [start=0]
   * @param {number} [end=array.length]
   * @return {Object} Returns the updated object.
   * @example fill({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', 6, 1, 3) // => { nested: { prop: [1, 6, 6, 4] } }
   * @see {@link https://lodash.com/docs#fill|lodash.fill} for more information.
   * @since 0.3.0
   */
  var fill = (0, _convert.convert)(_fill3.default);
  exports.fill = fill;
  exports.default = fill;
});